// cleanup_convert_to_typescript_file_VIEW_RECURRING_TRANSFERS

import React, { useContext } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import Modal, { TYPES } from '@glu/modal-react';
import { FormContext } from '@glu/validation-react';
import { Locale } from '@glu/locale-react';
import gluLocale from '@glu/locale';
import { UseFundsNextIcon } from '@glu/icons-react';

import useLocale from 'components/useLocale';
import { numberToCurrency } from 'utils/currency';
import { DATE_FORMAT } from 'constants.js';

import recurringTransferLocale from './recurringTransfer.locale';
import useStyles from './RecurringTransferDeleteModal.styles';

gluLocale.set(recurringTransferLocale);

export const DeleteModalComponent = ({ action, onCancel, submitDisabled }) => {
  const locale = useLocale();
  const form = useContext(FormContext);
  const { data } = form;
  const { modalDialog } = useStyles();

  const message = 'recurringTransfer.deleteConfirmMessage';

  return (
    <Modal
      btnPrimaryAttributes={{
        name: 'confirm',
        disabled: submitDisabled,
        className: 'btn btn-primary'
      }}
      btnPrimaryText={locale['common.continue']}
      btnTertiaryAttributes={{
        'data-qa': 'send-payment-confirm-cancel',
        className: 'btn btn-tertiary'
      }}
      btnTertiaryText={locale['common.cancel']}
      classes={{
        card: modalDialog
      }}
      dataQa="send-payment-confirm-modal"
      icon={UseFundsNextIcon}
      onBtnPrimaryClick={action}
      onBtnTertiaryClick={onCancel}
      onClose={onCancel}
      open
      type={TYPES.INFO}
    >
      <div>
        <div>
          <UseFundsNextIcon />
          <h2 className="modal-header">{locale['recurringTransfer.deleteHeader']}</h2>
          <p className="modal-text">
            <Locale
              localeKey={message}
              params={[
                <strong>{locale['recurringTransfer.name']}</strong>,
                <strong>{numberToCurrency(data?.amount)}</strong>,
                <strong>{data?.debitAccountId?.[0]?.shortName}</strong>,
                <strong>{data?.creditAccountId?.[0]?.shortName}</strong>,
                moment(data?.recurring?.startValue || new Date()).format(DATE_FORMAT)
              ]}
            />
          </p>
        </div>
      </div>
    </Modal>
  );
};

DeleteModalComponent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool
};

DeleteModalComponent.defaultProps = {
  submitDisabled: false
};

export default DeleteModalComponent;
